import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername]     = useState('');
  const [password, setPassword]     = useState('');
  const [showPass, setShowPass]     = useState(false);
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const { signIn } = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // PHP returns: { token, role, username, clientId? }
      const data = await login(username.trim(), password);
      signIn(data);
      navigate(data.role === 'superadmin' ? '/admin' : '/dashboard', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight:'100vh',
      background:'linear-gradient(135deg,#0f0f0f 0%,#1a1a2e 55%,#16213e 100%)',
      display:'flex',alignItems:'center',justifyContent:'center',
      fontFamily:"'DM Sans',sans-serif",padding:20,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&display=swap');
        *{box-sizing:border-box}
        .lcard{animation:slideUp 0.45s cubic-bezier(0.16,1,0.3,1) both}
        @keyframes slideUp{from{opacity:0;transform:translateY(28px)}to{opacity:1;transform:translateY(0)}}
        .linput{width:100%;padding:13px 15px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);border-radius:11px;color:#fff;font-size:15px;font-family:inherit;outline:none;transition:all 0.2s}
        .linput:focus{border-color:rgba(124,58,237,0.65);background:rgba(255,255,255,0.09);box-shadow:0 0 0 3px rgba(124,58,237,0.13)}
        .lbtn{width:100%;padding:13px;background:linear-gradient(135deg,#7c3aed,#4f46e5);border:none;border-radius:11px;color:#fff;font-size:15px;font-weight:600;font-family:inherit;cursor:pointer;transition:all 0.2s;letter-spacing:0.2px}
        .lbtn:hover:not(:disabled){transform:translateY(-1px);box-shadow:0 8px 24px rgba(124,58,237,0.4)}
        .lbtn:disabled{opacity:0.6;cursor:not-allowed}
        .eye-btn{position:absolute;right:13px;top:50%;transform:translateY(-50%);background:none;border:none;cursor:pointer;color:rgba(255,255,255,0.4);padding:4px;display:flex;align-items:center;transition:color 0.2s}
        .eye-btn:hover{color:rgba(255,255,255,0.75)}
      `}</style>

      {/* Background orbs */}
      <div style={{ position:'fixed',inset:0,overflow:'hidden',pointerEvents:'none' }}>
        <div style={{ position:'absolute',width:420,height:420,borderRadius:'50%',background:'#7c3aed',filter:'blur(90px)',opacity:0.13,top:-80,right:-80 }} />
        <div style={{ position:'absolute',width:320,height:320,borderRadius:'50%',background:'#2563eb',filter:'blur(80px)',opacity:0.12,bottom:-60,left:-60 }} />
      </div>

      <div className="lcard" style={{
        width:'100%',maxWidth:420,
        background:'rgba(255,255,255,0.04)',
        backdropFilter:'blur(20px)',
        border:'1px solid rgba(255,255,255,0.09)',
        borderRadius:22,padding:'46px 38px',
        position:'relative',zIndex:1,
      }}>
        {/* Header */}
        <div style={{ textAlign:'center',marginBottom:34 }}>
          <div style={{
            width:56,height:56,
            background:'linear-gradient(135deg,#7c3aed,#4f46e5)',
            borderRadius:16,display:'flex',alignItems:'center',justifyContent:'center',
            margin:'0 auto 18px',fontSize:26,
          }}>🏪</div>
          <h1 style={{ color:'#fff',fontSize:27,fontFamily:"'Syne',sans-serif",fontWeight:800,marginBottom:6,margin:'0 0 8px' }}>
            TiendaSaaS
          </h1>
          <p style={{ color:'rgba(255,255,255,0.4)',fontSize:14,margin:0 }}>
            Ingresá a tu panel de control
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ display:'flex',flexDirection:'column',gap:14 }}>
          <div>
            <label style={{ display:'block',color:'rgba(255,255,255,0.55)',fontSize:13,fontWeight:500,marginBottom:7 }}>Usuario</label>
            <input className="linput" type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="tu_usuario" required autoComplete="username" />
          </div>
          <div>
            <label style={{ display:'block',color:'rgba(255,255,255,0.55)',fontSize:13,fontWeight:500,marginBottom:7 }}>Contraseña</label>
            <div style={{ position:'relative' }}>
              <input
                className="linput"
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
                style={{ paddingRight:44 }}
              />
              <button
                type="button"
                className="eye-btn"
                onClick={() => setShowPass(v => !v)}
                tabIndex={-1}
                aria-label={showPass ? 'Ocultar contraseña' : 'Ver contraseña'}
              >
                {showPass ? (
                  /* ojo tachado */
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  /* ojo abierto */
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ background:'rgba(239,68,68,0.14)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:10,padding:'11px 14px',color:'#fca5a5',fontSize:13,textAlign:'center' }}>
              {error}
            </div>
          )}

          <button className="lbtn" type="submit" disabled={loading} style={{ marginTop:6 }}>
            {loading ? 'Ingresando...' : 'Ingresar →'}
          </button>
        </form>

        <p style={{ textAlign:'center',marginTop:22,color:'rgba(255,255,255,0.2)',fontSize:12 }}>
          © {new Date().getFullYear()} TiendaSaaS
        </p>
      </div>
    </div>
  );
}
